<div class="search-wrap" [class.contentV2]="viewConfigurations.useMobileViewWithTopMenu">

  <div class="flex">
    <div class="input-wrap">
      <input id="searchEvent" class="form-control form-control-sm" type="text" autocomplete="off" [(ngModel)]="searchValue" (input)="search()" placeholder="{{dynamicTranslations.searchForMatch_placeholder}}" (focusout)="clearSearchMsg()" (click)="search()" />
      <div *ngIf="searchValue.length>0" class="icon icon-cross" (click)="clearSearch()"></div>
    </div>

    <button id="searchButton" class="btn primary small icon icon-magnifier" [disabled]="!isSearchValid" (click)="search()"></button>
  </div>

  <div id="searchMessageButton" class="search-message" *ngIf="searchMessage !=''">{{searchMessage}}</div>

  <!-- <div class="dropdown-content" *ngIf="searchMessage ==''">
    <li class="item" (mousedown)="selectEvent(event)"  id="myDropdown" *ngFor="let event of events">
      {{event.eventName}}
    </li>
  </div> -->

  <div class="search-result box" *ngIf="events.length > 0">
    <div class="event" *ngFor="let event of events" (click)="selectEvent(event)">
      <div class="event-item">
        <div>
          <span class="bold">{{event.sportName}}</span> -
          <span class="bold" *ngIf="event.mappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</span>
          <span class="bold" *ngIf="event.mappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</span>
          {{event.regionName}}
        </div>
        <span class="competition-name">{{event.competitionName}}</span>
        <span class="event-name">{{event.eventName}}</span>
        <span class="competition-name" *ngIf="!isLive">{{event.dateTime| date:"dd.MM.yy. HH:mm"}}</span>
      </div>
      <span class="icon-wrap" *ngIf="isMobileView && !isLive && showFavoriteOption" (click)="addRemoveCompetitionToFavorites(event); $event.stopPropagation();">
        <i class="sporticon icon-xs sporticon-{{event.isCompetiionInFavorite ? 'star' : 'star-border'}}"></i>
        <!-- <i class="sporticon icon-xs sporticon-star"></i> -->
      </span>
      <span class="icon-wrap" *ngIf="isMobileView && isLive && showFavoriteOption" (click)="toogleFavorites(event); $event.stopPropagation();">
        <i class="sporticon icon-xs sporticon-{{event.isInFavorite ? 'star' : 'star-border'}}"></i>
        <!-- <i class="sporticon icon-xs sporticon-star"></i> -->
      </span>
    </div>
  </div>

  <!-- <div id="searchMessageButton" class="search-message" *ngIf="searchMessage !=''">{{searchMessage}}</div> -->
</div>

<!-- (focusout)="clearList()" -->
